var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphelement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffa0dc;}.cls-2{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M492.5,155.17H7.59c-.09,0-.09,0-.09-.09V53.93C8,53.3,18.79,39.47,36.41,39.47c37.92,0,42.44,108.38,81.73,108.38S168.36,50.31,208,50.31c22.49,0,28,16.26,49.67,16.26,31.53,0,40.47-39.74,63.86-39.74,31.52,0,31.52,81.28,71.08,81.28,48.59,0,53.11-56.8,99.8-56.89.09,0,.09,0,.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.86,53.93s10.93-14.46,28.9-14.46c37.93,0,42.45,108.38,81.74,108.38s50.21-97.54,89.87-97.54c22.48,0,28,16.26,49.67,16.26,31.52,0,40.46-39.74,63.86-39.74,31.51,0,31.51,81.28,71.07,81.28,48.6,0,52.66-56.8,99.44-56.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphelement);
export default __webpack_public_path__ + "static/media/graph element.b8a97c729569a413eab85cc645939d9f.svg";
export { ForwardRef as ReactComponent };